import { map } from 'lodash';
import { settings } from '~/config';

import { GET_FEATURE_LIST_ON_TOP_PAGE } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * Site Main Info Reducer
 * @param {*} state
 * @param {*} action
 */
export default function featureFolderList(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_FEATURE_LIST_ON_TOP_PAGE}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_FEATURE_LIST_ON_TOP_PAGE}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${GET_FEATURE_LIST_ON_TOP_PAGE}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
